observableQueryPromises